import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 26,
      height: 26,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      borderRadius: theme.shape.borderRadiusSmall,
      border: theme.shape.borderGray80,

      '& $buttonRemove': {
        visibility: 'hidden',
      },
      '&:hover': {
        boxShadow: theme.shape.boxShadowNormal,
        '& $buttonRemove': {
          visibility: 'visible',
        },
      },
    },
    loading: {
      backgroundColor: COLORS.gray.gray50,
      border: 'none',
    },
    buttonRemove: {
      backgroundColor: COLORS.gray.gray40,
      color: COLORS.neutral.white,
      borderRadius: '100%',
      border: '2px solid white',
      fontSize: theme.spacing(2),
      position: 'absolute',
      top: -8,
      right: -8,
      padding: theme.spacing(0.25),
      cursor: 'pointer',
    },
  }),
  { name: 'AttachmentImage' }
);
